export default {
  easing: 'cubic-bezier(0.25, 0.8, 0.25, 1)',
  normal: '0.24s',
  fast: '0.12s',
  slow: '0.48s'
}
